import LoginPage from "./Login/Login";
import "./Css/Login_App.css";

function LoginApp() {
  return (
    <div>
      <LoginPage />
    </div>
  );
}

export default LoginApp;
